import { useState, useEffect, useRef } from 'react';
import { useAuth } from 'contexts/AuthContext';

import { LiveAvatarSession, SessionEvent } from '@heygen/liveavatar-web-sdk';
import { Phone, Mic, BookOpen, Lightbulb, Loader2, X, Send, Sparkles, Lock } from 'lucide-react';
const CYBER = {
  cyan: 'var(--brand-primary, #00FFFF)',
  magenta: 'var(--brand-secondary, #FF00FF)',
  neonOrange: 'var(--brand-accent, #ffa600)',
  glassUltra: 'color-mix(in srgb, var(--brand-bg, #050612) 35%, transparent)',
  glassPanel: 'color-mix(in srgb, var(--brand-bg, #050612) 55%, transparent)',
};

const SUGGESTIONS = ["¿Cómo puedo mejorar?", "¿Qué módulo sigue?", "Explícame un concepto"];




// ─── CSS ──────────────────────────────────────────────────────────────────────
const Styles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');
    body { font-family:'Inter',sans-serif; margin:0; padding:0; }

    .neon-btn-green {
  background-color: var(--brand-accent, #f99f28); color: #000;
  box-shadow: 0 0 14px color-mix(in srgb, var(--brand-accent, #f99f28) 55%, transparent);
  border: 1px solid var(--brand-accent, #f99f28); transition: all 0.3s ease;
}
.neon-btn-green:hover {
  filter: brightness(1.15);
  box-shadow: 0 0 24px color-mix(in srgb, var(--brand-accent, #f99f28) 75%, transparent);
}
.neon-btn-green:disabled { opacity: 0.5; cursor: not-allowed; }

    .glass-blur { backdrop-filter:blur(20px); -webkit-backdrop-filter:blur(20px); }
    .neon-border-magenta-thin {
  border: 1px solid color-mix(in srgb, var(--brand-secondary, #FF00FF) 65%, transparent);
  box-shadow: 0 0 12px color-mix(in srgb, var(--brand-secondary, #FF00FF) 25%, transparent);
}
.neon-border-cyan-thin {
  border: 1px solid color-mix(in srgb, var(--brand-primary, #00FFFF) 50%, transparent);
  box-shadow: 0 0 12px color-mix(in srgb, var(--brand-primary, #00FFFF) 20%, transparent);
}
.neon-text-cyan {
  color: var(--brand-primary, #00FFFF);
  text-shadow: 0 0 10px color-mix(in srgb, var(--brand-primary, #00FFFF) 55%, transparent);
}

    .custom-scroll::-webkit-scrollbar { width:4px; }
    .custom-scroll::-webkit-scrollbar-track { background:transparent; }
    .custom-scroll::-webkit-scrollbar-thumb { background:rgba(255,255,255,0.1); border-radius:10px; }

    @keyframes fadeInUp {
      from { opacity:0; transform:translateY(10px); }
      to   { opacity:1; transform:translateY(0); }
    }
    .msg-appear { animation:fadeInUp 0.25s ease forwards; }

    @keyframes blink { 0%,100%{opacity:1} 50%{opacity:0.3} }
    .typing-dot { animation:blink 1.2s ease infinite; }
    .typing-dot:nth-child(2){ animation-delay:0.2s; }
    .typing-dot:nth-child(3){ animation-delay:0.4s; }

    @keyframes spin { from{transform:rotate(0deg)} to{transform:rotate(360deg)} }

    .tutor-root {
  height:100vh; max-height:100vh; overflow:hidden;
  display:flex; flex-direction:column; align-items:center; justify-content:center;
  padding:12px; box-sizing:border-box;
  background: transparent;
  color: var(--brand-text, #fff);
}
    .tutor-wrapper {
      width:100%; max-width:900px; height:100%; max-height:100%;
      display:flex; flex-direction:column; gap:10px; overflow:hidden;
    }
    .chat-panel {
      display:flex; flex-direction:column; flex:1; min-height:0;
      border-radius:24px; border:1px solid rgba(255,255,255,0.1); overflow:hidden;
    }
    .messages-area {
      flex:1; min-height:0; padding:20px 24px;
      overflow-y:auto; display:flex; flex-direction:column; gap:12px;
    }
    .footer-cards {
  display:grid; grid-template-columns:repeat(auto-fit, minmax(180px, 1fr)); gap:8px; flex-shrink:0;
}
    .footer-card {
      padding:10px 14px; border-radius:14px;
      display:flex; align-items:center; gap:10px;
      border:1px solid rgba(255,255,255,0.1);
    }


    
    .did-modal-overlay {
      position:fixed; inset:0; z-index:1000;
      background:rgba(2,4,10,0.85);
      display:flex; align-items:center; justify-content:center;
      padding:16px; box-sizing:border-box;
    }
    .did-modal-box {
      width:100%; max-width:960px; height:100%; max-height:640px;
      display:flex; flex-direction:column;
      background:#05070f; border-radius:24px; overflow:hidden;
      border:1px solid rgba(255,255,255,0.1);
      box-shadow:0 0 60px rgba(0,255,255,0.08);
    }
    .did-modal-header {
      display:flex; align-items:center; justify-content:space-between;
      padding:14px 20px; border-bottom:1px solid rgba(255,255,255,0.08);
      background:rgba(255,255,255,0.02);
    }
    .liveavatar-main {
      position:relative; flex:1; min-height:0;
      background:#000;
    }
    .liveavatar-main iframe {
      width:100%; height:100%; border:none; display:block;
    }
    .pip-cam {
      position:absolute; bottom:16px; right:16px; z-index:3;
      width:140px; height:105px; border-radius:14px; overflow:hidden;
      border:2px solid rgba(255,0,255,0.4);
      box-shadow:0 0 20px rgba(255,0,255,0.15);
      background:#0a0a1a;
    }
    .pip-cam-label {
      position:absolute; top:6px; left:6px; z-index:4;
      display:flex; align-items:center; gap:4px;
      padding:2px 6px; border-radius:999px;
      background:rgba(0,0,0,0.5); backdrop-filter:blur(4px);
    }
    .pip-cam-nodevice {
      width:100%; height:100%; display:flex; flex-direction:column;
      align-items:center; justify-content:center; gap:4px;
    }
    .did-cam-dot {
      width:6px; height:6px; border-radius:50%;
      background:#FF00FF; box-shadow:0 0 6px #FF00FF;
    }
    .liveavatar-loading {
      position:absolute; inset:0; z-index:2;
      display:flex; flex-direction:column; align-items:center; justify-content:center;
      gap:10px; background:#05070f;
    }
    .did-modal-footer {
      display:flex; align-items:center; justify-content:space-between;
      padding:14px 20px; border-top:1px solid rgba(255,255,255,0.08);
      background:rgba(255,255,255,0.02);
    }
    .live-badge {
      display:flex; align-items:center; gap:6px;
      padding:4px 10px; border-radius:999px;
      background:rgba(0,255,136,0.08); border:1px solid rgba(0,255,136,0.3);
    }
    .live-dot {
      width:7px; height:7px; border-radius:50%;
      background:#00ff88; box-shadow:0 0 8px #00ff88;
      animation:blink 1.2s ease infinite;
    }

    .call-pulse {
      position:absolute; inset:0; border-radius:50%;
      border:2px solid var(--brand-primary, #00FFFF);
      animation: callPulse 1.8s ease-out infinite;
    }
    @keyframes callPulse {
      from { transform:scale(1);   opacity:0.7; }
      to   { transform:scale(1.9); opacity:0; }
    }
      /* Texto con el color de la empresa (sustituye a text-white de Tailwind) */
.tutor-root .text-white { color: var(--brand-text, #fff); }
.tutor-root .text-white\/90 { color: rgb(var(--brand-text-rgb, 255 255 255) / .9); }
.tutor-root .text-white\/40 { color: rgb(var(--brand-text-rgb, 255 255 255) / .4); }

.tutor-input:focus { border-color: var(--brand-primary, #00FFFF) !important; }
.tutor-avatar { border: 1px solid var(--brand-primary, #00FFFF); }
.tutor-badge {
  background: color-mix(in srgb, var(--brand-primary, #00FFFF) 8%, transparent);
  border: 1px solid color-mix(in srgb, var(--brand-primary, #00FFFF) 25%, transparent);
  color: var(--brand-primary, #00FFFF);
}
.tutor-dot { background: var(--brand-secondary, #FF00FF); }
.tutor-sug {
  color: var(--brand-accent, #ffa600);
  background: color-mix(in srgb, var(--brand-accent, #ffa600) 8%, transparent);
  border: 1px solid color-mix(in srgb, var(--brand-accent, #ffa600) 25%, transparent);
}
.tutor-sug:hover { background: color-mix(in srgb, var(--brand-accent, #ffa600) 18%, transparent); }
  `}</style>
);



const VideoCallModal = ({ onClose }) => {
  const { api } = useAuth();
  // 'ringing' → 'connecting' → 'live' | 'error'
  const [phase, setPhase] = useState('ringing');
  const [errorMsg, setErrorMsg] = useState('');
  const [callTime, setCallTime] = useState(0);
  const [camReady, setCamReady] = useState(false);
  const [camError, setCamError] = useState(false);

  const avatarVideoRef = useRef(null);
  const webcamRef = useRef(null);
  const sessionRef = useRef(null);
  const endedRef = useRef(false);
  const audioCtxRef = useRef(null);          // ← línea nueva
 const sessionIdRef = useRef(null);   // ← añadir
  const pingRef = useRef(null);
 const reportEnd = () => {            // ← añadir
    clearInterval(pingRef.current);
    pingRef.current = null;
    const sid = sessionIdRef.current;
    sessionIdRef.current = null;
    if (sid) api.post(`/liveavatar/session/${sid}/end`).catch(() => {});
  };
const stopSession = () => {
  reportEnd();
  const s = sessionRef.current;
  sessionRef.current = null;
  if (!s || endedRef.current) return;
  endedRef.current = true;
  try {
    Promise.resolve(s.stop?.()).catch(() => {});
  } catch {}
};

useEffect(() => () => {                    // ← sustituye al anterior
  stopSession();
  audioCtxRef.current?.close().catch(() => {});
}, []);


  // Cronómetro solo en directo
  useEffect(() => {
    if (phase !== 'live') return;
    const t = setInterval(() => setCallTime(s => s + 1), 1000);
    return () => clearInterval(t);
  }, [phase]);

  // Tu cámara solo cuando la llamada está en directo
  useEffect(() => {
    if (phase !== 'live') return;
    let stream = null;
    navigator.mediaDevices
      ?.getUserMedia({ video: { facingMode: 'user' }, audio: false })
      .then(s => {
        stream = s;
        if (webcamRef.current) {
          webcamRef.current.srcObject = s;
          setCamReady(true);
        }
      })
      .catch(() => setCamError(true));
    return () => stream?.getTracks().forEach(t => t.stop());
  }, [phase]);

    const boostAudio = (video, gainValue = 2) => {
  const stream = video.srcObject;
  if (!stream || !stream.getAudioTracks().length) return;
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    const ctx = new Ctx();
    ctx.resume().catch(() => {});
    const src = ctx.createMediaStreamSource(new MediaStream(stream.getAudioTracks()));
    const gain = ctx.createGain();
    gain.gain.value = gainValue;
    src.connect(gain);
    gain.connect(ctx.destination);
    video.muted = true; // evita oír el audio duplicado
    audioCtxRef.current = ctx;
  } catch (e) {
    console.warn('No se pudo amplificar el audio', e);
    video.muted = false;
  }
};
  // El clic en CONTESTAR es el gesto del usuario que desbloquea audio y micro
  const answer = async () => {
  setPhase('connecting');
  endedRef.current = false;
  try {
    const { data } = await api.post('/liveavatar/session');
    sessionIdRef.current = data.session_id;
    const session = new LiveAvatarSession(data.session_token);
    sessionRef.current = session;

    let attached = false;
    const goLive = () => {
      if (attached || !avatarVideoRef.current) return;
      attached = true;
      const video = avatarVideoRef.current;
      session.attach(video);
      video.muted = false;
      video.volume = 1;
      setPhase('live');
      boostAudio(video);
      pingRef.current = setInterval(() => {
      if (sessionIdRef.current) api.post(`/liveavatar/session/${sessionIdRef.current}/ping`).catch(() => {});
    }, 30000);
    };

    session.on(SessionEvent.SESSION_STREAM_READY, goLive);
    session.on(SessionEvent.SESSION_DISCONNECTED, () => {
      endedRef.current = true;
      reportEnd();
      sessionRef.current = null;
      setErrorMsg('La llamada se ha cortado.');
      setPhase('error');
    });

    await session.start();
    goLive(); // respaldo por si el evento no llegó
    } catch (e) {
    console.error('LiveAvatar error:', e);
    endedRef.current = true;
    reportEnd();
    sessionRef.current = null;
    setErrorMsg(
      e.response?.status === 403
        ? 'La videollamada no está incluida en tu plan.'
        : 'No se pudo conectar con LAURA. Inténtalo de nuevo.'
    );
    setPhase('error');
  }
};

  const fmt = s =>
    `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`;

  const statusLabel = {
    ringing: 'LLAMADA ENTRANTE',
    connecting: 'CONECTANDO…',
    live: 'EN DIRECTO',
    error: 'LLAMADA FINALIZADA',
  }[phase];
  

  return (
    <div className="did-modal-overlay">
      <div className="did-modal-box">
        <div className="did-modal-header">
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <div className="live-badge">
              <span className="live-dot" />
              <span style={{ color:'#00ff88', fontSize:10, fontWeight:900, letterSpacing:'0.25em' }}>
                {statusLabel}
              </span>
            </div>
            {phase === 'live' && (
              <span style={{ fontFamily:'monospace', color:'#fff', fontSize:17 }}>{fmt(callTime)}</span>
            )}
          </div>
          <span style={{ color:'rgba(255,255,255,0.3)', fontSize:11, fontWeight:700, letterSpacing:'0.3em' }}>
            SESIÓN CON LAURA · AVATAR IA
          </span>
          <button onClick={onClose} style={{
            padding:'8px 10px', borderRadius:10, cursor:'pointer',
            background:'rgba(255,255,255,0.06)', border:'1px solid rgba(255,255,255,0.12)',
            color:'#fff', display:'flex', alignItems:'center',
          }}>
            <X size={18} />
          </button>
        </div>

        <div className="liveavatar-main">
          {/* Vídeo del avatar: siempre montado para poder hacer attach() */}
          <video
            ref={avatarVideoRef}
            autoPlay
            playsInline
            style={{ width:'100%', height:'100%', objectFit:'contain', background:'#000', display:'block' }}
          />

          {/* Pantalla de llamada */}
          {phase !== 'live' && (
            <div style={{
              position:'absolute', inset:0, zIndex:2, background:'#05070f',
              display:'flex', flexDirection:'column', alignItems:'center',
              justifyContent:'center', gap:14,
            }}>
              <div style={{ position:'relative', width:120, height:120 }}>
                {phase === 'ringing' && (
                  <>
                    <span className="call-pulse" />
                    <span className="call-pulse" style={{ animationDelay:'0.8s' }} />
                  </>
                )}
                <img src="/tutor.jpg" alt="" style={{
                  position:'relative', width:120, height:120, borderRadius:'50%',
                  objectFit:'cover', border:'2px solid var(--brand-primary, #00FFFF)',
                }} />
              </div>
              <h2 style={{ color:'#fff', margin:0, fontSize:22, fontWeight:800 }}>LAURA</h2>
              <p style={{ color:'rgba(255,255,255,0.5)', margin:0, fontSize:13 }}>
                {phase === 'ringing' && 'te está llamando…'}
                {phase === 'connecting' && 'Conectando…'}
                {phase === 'error' && errorMsg}
              </p>

              {phase === 'connecting' && (
                <Loader2 size={26} color="#00FFFF" style={{ animation:'spin 1s linear infinite' }} />
              )}

              {phase === 'ringing' && (
                <button onClick={answer} style={{
                  marginTop:8, padding:'14px 44px', borderRadius:999, border:'none',
                  background:'#16a34a', color:'#fff', fontWeight:900, fontSize:13,
                  letterSpacing:'0.2em', cursor:'pointer',
                  boxShadow:'0 0 24px rgba(22,163,74,0.6)',
                  display:'flex', alignItems:'center', gap:10,
                }}>
                  <Phone size={16} /> CONTESTAR
                </button>
              )}

              {phase === 'error' && (
                <button onClick={() => { setErrorMsg(''); setPhase('ringing'); }} style={{
                  marginTop:8, padding:'10px 30px', borderRadius:999, border:'none',
                  background:'#16a34a', color:'#fff', fontWeight:900, fontSize:12,
                  letterSpacing:'0.2em', cursor:'pointer',
                }}>
                  VOLVER A LLAMAR
                </button>
              )}
            </div>
          )}

          {/* Tu cámara (PiP) */}
          {phase === 'live' && (
            <div className="pip-cam">
              <div className="pip-cam-label">
                <span className="did-cam-dot" />
                <span style={{ color:'#FF00FF', fontSize:9, fontWeight:900, letterSpacing:'0.2em' }}>TÚ</span>
              </div>
              {camError ? (
                <div className="pip-cam-nodevice">
                  <span style={{ fontSize:22 }}>📷</span>
                  <span style={{ color:'rgba(255,255,255,0.3)', fontSize:10 }}>Sin cámara</span>
                </div>
              ) : (
                <video ref={webcamRef} autoPlay playsInline muted style={{
                  opacity: camReady ? 1 : 0, transition:'opacity 0.4s',
                  width:'100%', height:'100%', objectFit:'cover',
                  transform:'scaleX(-1)', display:'block',
                }} />
              )}
            </div>
          )}
        </div>

        <div className="did-modal-footer">
          <div style={{ display:'flex', alignItems:'center', gap:8 }}>
            <Mic size={14} color="#00FFFF" />
            <span style={{ color:'rgba(255,255,255,0.4)', fontSize:11 }}>
              Habla directamente con LAURA — escucha y responde en tiempo real
            </span>
          </div>
          <button
            onClick={onClose}
            onMouseEnter={e => e.currentTarget.style.background = '#b91c1c'}
            onMouseLeave={e => e.currentTarget.style.background = '#dc2626'}
            style={{
              padding:'10px 36px', borderRadius:16, background:'#dc2626',
              color:'#fff', fontWeight:900, fontSize:12, letterSpacing:'0.2em',
              border:'none', cursor:'pointer', boxShadow:'0 0 16px rgba(220,38,38,0.4)',
              transition:'background 0.2s',
            }}>
            {phase === 'live' ? 'FINALIZAR SESIÓN' : 'COLGAR'}
          </button>
        </div>
      </div>
    </div>
  );
};

const UpgradeModal = ({ what, onClose }) => (
  <div className="did-modal-overlay" onClick={onClose}>
    <div onClick={e => e.stopPropagation()} style={{
      width: '100%', maxWidth: 420, padding: 28, borderRadius: 24, textAlign: 'center',
      background: '#05070f', border: '1px solid var(--brand-accent, #ffa600)',
      boxShadow: '0 0 40px color-mix(in srgb, var(--brand-accent, #ffa600) 30%, transparent)',
    }}>
      <div style={{
        width: 56, height: 56, borderRadius: '50%', margin: '0 auto 14px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        background: 'color-mix(in srgb, var(--brand-accent, #ffa600) 15%, transparent)',
        border: '1px solid var(--brand-accent, #ffa600)',
      }}>
        <Sparkles size={26} color="var(--brand-accent, #ffa600)" />
      </div>
      <h2 style={{ color: '#fff', margin: '0 0 8px', fontSize: 20, fontWeight: 800 }}>
        Pásate al plan PLUS
      </h2>
      <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 13, lineHeight: 1.6, margin: '0 0 20px' }}>
        {what === 'avatar'
          ? 'La videollamada con el avatar IA no está incluida en tu plan actual.'
          : 'El tutor IA no está incluido en tu plan actual.'}
        {' '}Habla con el administrador de tu empresa para activarlo.
      </p>
      <button onClick={onClose} className="neon-btn-green"
        style={{ padding: '10px 32px', borderRadius: 12, fontWeight: 900, fontSize: 12, letterSpacing: '0.2em', cursor: 'pointer' }}>
        ENTENDIDO
      </button>
    </div>
  </div>
);

// ─── MAIN COMPONENT ───────────────────────────────────────────────────────────

const AITutor = ({ user }) => {
  const { api, user: authUser } = useAuth();
  const [showVideoCall, setShowVideoCall] = useState(false); 
  const [messages, setMessages] = useState([
    {
      role: 'assistant',
      content: '¡Hola! Soy LAURA, tu tutora IA personal. ¿En qué puedo ayudarte hoy?\n\nHe adaptado mi enseñanza a tu estilo de aprendizaje. ¿Por dónde empezamos?',
    }
  ]);
  const [inputValue, setInputValue] = useState('');
  const [isLoading,  setIsLoading]  = useState(false);
  const [upgrade, setUpgrade] = useState(null);  
  const canCall = !!authUser?.features?.avatar_call;
  const canTutor = !!authUser?.features?.ai_tutor;
  const messagesEndRef = useRef(null);
  const inputRef       = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, isLoading]);

  const sendMessage = async (text) => {
    const trimmed = text.trim();
    if (!trimmed || isLoading) return;
    if (!canTutor) { setUpgrade('tutor'); return; }
    const newMessages = [...messages, { role: 'user', content: trimmed }];
    setMessages(newMessages);
    setInputValue('');
    setIsLoading(true);

    try {
      const historial = newMessages.slice(-10).map(m =>
        `${m.role === 'user' ? 'Alumno' : 'LAURA'}: ${m.content}`
      ).join('\n');

      const response = await api.post('/ai/chat', {
          message: trimmed,
          context: `Eres LAURA, tutora IA de una plataforma de formación empresarial.

REGLAS ESTRICTAS QUE DEBES SEGUIR SIEMPRE:
1. SOLO hablas de temas relacionados con: los módulos de formación, el aprendizaje, habilidades profesionales, conceptos de los cursos, progreso del alumno, o la propia plataforma.
2. Si el usuario pregunta algo que NO tiene relación con la formación (el tiempo, compras, deportes, política, entretenimiento, etc.), responde amablemente: "Soy tu tutora de formación, solo puedo ayudarte con temas relacionados con tus cursos y aprendizaje. ¿Tienes alguna duda sobre tus módulos?"
3. SIEMPRE responde en ESPAÑOL.
4. Sé concisa, amigable y tutea al alumno.
5. TEN EN CUENTA el historial de la conversación para dar respuestas coherentes y con contexto.
6. No repitas la misma palabra de apertura dos veces seguidas en la conversación.
7. NUNCA inventes recursos que no existen: no menciones podcasts, grabaciones de audio, vídeos, enlaces, botones, rutas de menú (ej. "Módulo X → Recursos → Y") ni nombres de archivos concretos si no tienes constancia real de que existen en esta conversación. No tienes acceso a una lista de recursos de la plataforma. Si el alumno pide material de un tipo concreto (audio, vídeo, PDF...) que no puedes confirmar que existe, dile honestamente que no tienes esa información y sugiérele revisar el contenido de la unidad directamente en la plataforma, sin nombrar nada específico que no conozcas con certeza.
8. NUNCA generes enlaces con "#" o URLs de ningún tipo. Tú no navegas ni conoces la estructura de menús de la app.

HISTORIAL DE ESTA CONVERSACIÓN:
${historial}


Responde SOLO al último mensaje del alumno teniendo en cuenta el historial anterior.`,
      });

      const reply = response.data.response || 'Lo siento, no obtuve respuesta.';
      setMessages(prev => [...prev, { role: 'assistant', content: reply }]);

    } catch (err) {
      console.error('AI Chat error:', err);
      setMessages(prev => [
        ...prev,
        { role: 'assistant', content: `⚠️ ${err.response?.data?.detail || err.message}` },
      ]);
    } finally {
      setIsLoading(false);
      setTimeout(() => inputRef.current?.focus(), 150);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      sendMessage(inputValue);
    }
  };

  return (
    <div className="tutor-root">
      <Styles />
      {canCall && showVideoCall && <VideoCallModal onClose={() => setShowVideoCall(false)} />}
      {upgrade && <UpgradeModal what={upgrade} onClose={() => setUpgrade(null)} />}
      <div className="tutor-wrapper">

        {/* ── Header ── */}
        <div
          className="p-4 rounded-2xl flex items-center justify-between border border-white/10 shadow-2xl glass-blur flex-shrink-0"
          style={{ background: CYBER.glassPanel }}
        >
          <div className="flex items-center gap-4">
            <div className="relative">
              <img
                src="/tutor.jpg"
                alt=""
                className="w-12 h-12 rounded-full tutor-avatar p-1 object-cover"
              />
              <span className="absolute bottom-0.5 right-0.5 w-3 h-3 bg-[#00FF00] rounded-full border-2 border-black shadow-[0_0_8px_#00FF00]" />
            </div>
            <div>
              <h1 className="text-xl font-black text-white tracking-tight neon-text-cyan leading-none">LAURA</h1>
              <p className="text-white/40 text-[9px] font-bold tracking-[0.3em] mt-0.5 uppercase">TUTOR IA PERSONAL</p>
              {canCall && (
                <div className="mt-1 inline-flex items-center gap-2 px-2 py-0.5 rounded-md tutor-badge">
                  <span className="text-[8px] font-bold tracking-wider uppercase">AVATAR IA EXCLUSIVO</span>
                </div>
              )}
            </div>
          </div>
          <button
  onClick={() => (canCall ? setShowVideoCall(true) : setUpgrade('avatar'))}
  className="flex items-center gap-2 px-5 py-2.5 rounded-xl font-black text-xs tracking-widest neon-btn-green"
>
  {canCall ? <Phone className="w-4 h-4 fill-black" /> : <Lock className="w-4 h-4" />} VIDEOLLAMADA
</button>
          
        </div>

        {/* ── Chat Panel ── */}
        <div
          className="chat-panel glass-blur"
          style={{ background: CYBER.glassUltra }}
        >
          {/* Mensajes */}
          <div className="messages-area custom-scroll">
            {messages.map((msg, i) => (
              <div
                key={i}
                className={`msg-appear flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
              >
                <div
                  className={`max-w-[80%] p-4 rounded-2xl text-sm leading-relaxed font-medium whitespace-pre-wrap ${
                    msg.role === 'user'
                      ? 'rounded-tr-none neon-border-cyan-thin text-white/90'
                      : 'rounded-tl-none neon-border-magenta-thin text-white/90'
                  }`}
                  style={{
                    background: msg.role === 'user'
                      ? 'rgba(0,255,255,0.05)'
                      : 'rgba(255,0,255,0.03)',
                  }}
                >
                  {msg.content}
                </div>
              </div>
            ))}

            {isLoading && (
              <div className="flex justify-start msg-appear">
                <div
                  className="p-4 rounded-2xl rounded-tl-none neon-border-magenta-thin flex items-center gap-2"
                  style={{ background:'rgba(255,0,255,0.03)' }}
                >
                  <span className="typing-dot w-2 h-2 rounded-full tutor-dot inline-block" />
                  <span className="typing-dot w-2 h-2 rounded-full tutor-dot inline-block" />
                  <span className="typing-dot w-2 h-2 rounded-full tutor-dot inline-block" />
                </div>
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Sugerencias */}
          <div className="px-6 py-3 bg-black/20 border-t border-white/5 flex-shrink-0">
            <div className="flex items-center gap-2 mb-2">
              <Lightbulb className="w-3 h-3" style={{ color: 'var(--brand-accent, #ffa600)' }} />
              <p className="text-[9px] font-black tracking-widest uppercase" style={{ color: 'var(--brand-accent, #ffa600)' }}>SUGERENCIAS:</p>
            </div>
            <div className="flex flex-wrap gap-2">
              {SUGGESTIONS.map(s => (
                <button
                  key={s}
                  onClick={() => sendMessage(s)}
                  disabled={isLoading}
                  className="px-3 py-1 rounded-full tutor-sug text-[10px] font-bold transition-all disabled:opacity-40"
                >
                  {s}
                </button>
              ))}
            </div>
          </div>

          {/* Input */}
          <div className="p-4 bg-black/40 border-t border-white/10 flex-shrink-0">
            <div className="flex gap-3">
              <input
                ref={inputRef}
                type="text"
                value={inputValue}
                onChange={e => setInputValue(e.target.value)}
                onKeyDown={handleKeyDown}
                placeholder="Escribe a LAURA... (Enter para enviar)"
                disabled={isLoading}
                className="flex-1 bg-white/5 border border-white/10 rounded-xl px-5 py-3 text-sm outline-none tutor-input transition-all disabled:opacity-50"              />
              <button
                onClick={() => sendMessage(inputValue)}
                disabled={isLoading || !inputValue.trim()}
                className="px-6 rounded-xl text-black font-black text-xs tracking-widest neon-btn-green flex items-center gap-2"
              >
                {isLoading
                  ? <Loader2 className="w-4 h-4 animate-spin" />
                  : <Send className="w-4 h-4" />}
                ENVIAR
              </button>
            </div>
          </div>
        </div>

        {/* ── Footer Cards (sin videollamada) ── */}
        <div className="footer-cards flex-shrink-0">
          {[
  { title:'EXCLUSIVO POR EMPRESA', icon:BookOpen, color:CYBER.magenta },
  { title:'HABLA Y ESCUCHA SOLO',  icon:Mic,      color:CYBER.cyan },
  { title:'VIDEOLLAMADA REAL',     icon:Phone,    color:CYBER.neonOrange },
].map(card => (
            <div
              key={card.title}
              className="footer-card glass-blur"
              style={{ background:CYBER.glassPanel, borderBottom:`3px solid ${card.color}` }}
            >
              <div className="w-8 h-8 rounded-lg flex items-center justify-center bg-white/5 flex-shrink-0">
                <card.icon className="w-4 h-4" style={{ color:card.color }} />
              </div>
              <span className="text-white text-[9px] font-black tracking-widest">{card.title}</span>
            </div>
          ))}
        </div>

      </div>
    </div>
  );
};

export default AITutor;